import { Alert, Button, Typography } from "@mui/material";

import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { NavigateFunction } from "react-router-dom";
import { SerializedError } from "@reduxjs/toolkit";
import { globalStyles } from "./styles";
import i18n from "../../i18n";

export const getErrorText = (
  error?: FetchBaseQueryError | SerializedError
): string => {
  console.error(error);
  if (error) {
    if ("status" in error) {
      // FetchBaseQueryError
      if (typeof error.status === "number") {
        return (
          "HTTP code " +
          error.status +
          ": " +
          ((error.data as any).message ||
            (error.data as any).response_code ||
            "No further information")
        );
      } else if (typeof error.status === "string") {
        return (
          "Error: " + error.status + (error.error ? " - " + error.error : "")
        );
      }
    } else {
      // SerializedError
      if (error.message) {
        return "Serialized error: " + error.message;
      } else if (error.name) {
        return "Serialized error: " + error.name;
      }
    }
  }
  return i18n.t("common:unknownError");
};

export const getErrorComponent = (
  error: FetchBaseQueryError | SerializedError,
  navigate: NavigateFunction
): JSX.Element => {
  const errorText = getErrorText(error);
  return (
    <Alert severity="error">
      <Typography variant="body2">{errorText}</Typography>
      <Button
        variant="contained"
        onClick={() => navigate(0)}
        sx={globalStyles.gapTop}
      >
        {i18n.t("common:reloadPage")}
      </Button>
    </Alert>
  );
};
